import React from 'react';

import { Button } from '../../components/Button';
import { Section } from '../../components/Section';

import logo from './images/logo.png';
import nutri from './images/1-a.png';
import fruits from './images/1-b.png';
import Decoration1Right from "./images/1-right.png";
import Decoration1Left from "./images/1-left.png";

import circles from './images/2-a.png';
import seeds from './images/2-b.png';
import nis from './images/2-c.png';

import Decoration2Right from "./images/2-right.png";
import Decoration2Left from "./images/2-left.png";


import './styles/index.scss';


export const Landing = () => {
  return (
    <div className="Landing Landing--nutri-sapere">
      <Section
      decorations={{
        right: Decoration1Right,
        left: Decoration1Left
      }}>
        <div className="container text-center pt-4">
          <img src={logo} className="logo"/>
          <img src={nutri} className="nutri" />
          <p className="bg-green">Da Pam RetailPro sono arrivati</p>
          <p className="bg-green">i puzzle 3D di Ravensburger!</p>
          <p><b>Vieni a scoprirli!</b></p>
          <img src={fruits} className="fruits" />
          <p>
            <b>Dal 21 aprile al 30 giugno 2023</b><br />
            con soli € 2,50 ogni € 10 di spesa, riceverai<br />
            <b>un puzzle 3D a sorpresa e<br />
              una bustina con i semi da piantare.</b>
          </p>
        </div>
      </Section>
      <Section
        decorations={{
          right: Decoration2Right,
          left: Decoration2Left
        }}>
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-6">
              <h3>Un puzzle 3D<br />
              a sorpresa<br />
                <br />
              … con le relative<br />
                Istruzioni!</h3>
              <p>Collezionali tutti: pomodoro, peperone,<br />
                fragola, zucchina, basilico e lattuga.</p>
            </div>
            <div className="col-12 col-md-6">
              <img src={circles} className="circles" />
            </div>
          </div>
          <div className="row reverse">
            <div className="col-12 col-md-6">
              <h3>Una bustina di semi<br />
                da piantare</h3>
              <p>Ti basta un vasetto e puoi già
                passare alla pratica.</p>
            </div>
            <div className="col-12 col-md-6">
              <img src={seeds} className="seeds" />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6">
              <h3>Informazioni e curiosità<br/>
                sulla piantina da<br/>
                seminare</h3>
              <p>Perché conoscere quello che si mangia
                è importante!</p>
            </div>
            <div className="col-12 col-md-6">
              <img src={nis} className="nis" />
            </div>
          </div>
        </div>
      </Section>
      <Section>
        <div className="container">
          <Button label="Leggi il regolamento completo" backgroundColor="#FF4B4B" color="#FFFFFF" href="https://it-pampanorama-dev.s3.eu-west-3.amazonaws.com/etc/nutri-sapere/REGOLAMENTO_SELF_RAVENSBURGER_def.pdf"></Button>
          <a href="https://pamretailpro.it/landing/nutri-il-sapere/" target="_top" className="pt-3">Clicca qui per scoprire di più sul progetto Nutri il Sapere</a>
        </div>
      </Section>
    </div>
  )
}
